module.exports = __webpack_public_path__ + "img/img0.ada384a6.png";